<!-- links of the record: as many as fit on the line, the others behind "+N" (click) -->
<ul #row class="smart-button p-grid">
  @for (button of buttons(); track button.key) {
    <li smart-button-ui [data]="button" [compact]="true" [attr.data-key]="button.key"></li>
  }
</ul>

@if (hidden().length) {
  @let allHidden = hidden().length === buttons().length;
  <div class="smart-button-more" [class.smart-button-more--all]="allHidden">
    <!-- none fits: one "Links" menu like "Processes" (a lone "+N" in the middle of the bar read as a glitch) -->
    <button
      #moreBtn
      type="button"
      class="smart-button-more-btn"
      [class.smart-button-more-btn--menu]="allHidden"
      aria-haspopup="menu"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="'editView.moreSmartButtons' | translate"
      [title]="'editView.moreSmartButtons' | translate"
      (click)="toggle($event)">
      @if (allHidden) {
        <i aria-hidden="true" class="fa-solid fa-link"></i>
        <span>{{ 'editView.links' | translate }}</span>
        <span class="smart-button-more-count">{{ hidden().length }}</span>
      } @else {
        +{{ hidden().length }}
      }
      <i aria-hidden="true" class="fa-solid fa-chevron-down smart-button-more-caret"></i>
    </button>
    @if (open()) {
      <ul class="smart-button-more-list" role="menu" (click)="close()" (keydown.escape)="close(true)">
        @for (button of hidden(); track button.key) {
          <li smart-button-ui [data]="button" [menuItem]="true"></li>
        }
      </ul>
    }
  </div>
}
